<template>
  <div>
    <div
      v-show="isProductsOpen"
      class="products-dropdown"
    >
      <div class="content-max-width" v-show="!isProductsChildrenOpen">
        <div class="flex">

          <article
            v-for="product of categories"
            :key="product.id"
          >
            <!-- <a :href="product.url"> -->
            <a @click="toggleChldrenProducts(product)">
              <div class="image">
                <img :src="product.image" :alt="product.title">
              </div>
              <h4>{{ product.title }}</h4>
            </a>
          </article>

        </div>
      </div>

      <div class="content-max-width children-cats" v-show="isProductsChildrenOpen">

        <h3 @click="closeChldrenProducts()">
          <img src="/images/back.png" alt="Host Service Products">
          {{ childrenCatTitle }}
        </h3>

        <div class="flex">
          <!-- <article key="0">
              <a @click="closeChldrenProducts()">
              <div class="image">
                <img src="/images/back.png" alt="Host Service Products">
              </div>
              <h4>{{ childrenCatTitle }}</h4>
            </a>
          </article> -->

          <article
            v-for="product of childrenCat"
            :key="product.id"
          >

            <a @click="toggleChldrenProducts(null,product)" v-if="product.children.length > 0">
              <div class="image">
                <img :src="product.image" :alt="product.title">
              </div>
              <h4>{{ product.title }}</h4>
            </a>
            <a v-else :href="product.url">
              <div class="image">
                <img :src="product.image" :alt="product.title">
              </div>
              <h4>{{ product.title }}</h4>
            </a>
          </article>
        </div>
      </div>

    </div>

  <div
      v-if="description && description.length > 0"
      class="wysywig category-main-description"
      v-html="description"
  ></div>
  </div>
</template>

<style scoped>
    .wysywig {
        margin: 50px 0 0;
    }

    .products-dropdown {
        margin-top: 40px;
    }

    h3 {
        line-height: 30px;
        cursor: pointer;
        margin-bottom: 30px;
    }
    h3 img {
        width: 30px;
        float: left;
    }

    article {
        padding: 0 10px 20px 0;
    }

    .image img {
         width: 200px;

        @media (min-width: 1025px) {

           width: 300px;

            @media (min-width: 894px) {
                width: 300px;
            }
        }



    }
    article h4 {
        text-align: center;
        font-size: 14px;
        line-height: 28px;
        @media (min-width: 1025px) {
            font-size: 18px;
            line-height: 28px;
        }
    }
</style>

<script>

export default {
  props: [
    'categories',
    'description',
  ],

  data () {
    return {
      isOpen: false,
      isSearchOpen: false,
      isProductsOpen: false,
      isProductsChildrenOpen: false,
      isMobProductsOpen: false,
      childrenCat: [],
      childrenCatTitle: '',
      parentProduct: null,
      prevProduct: null
    };
  },

  mounted () {
    this.toggleProducts()
  },

  methods: {
    toggleProducts () {
      if (!this.isProductsOpen) {
        console.log('testing')
        this.isProductsOpen = true
        // this.$parent.isMenuOpen = true
      } else {
        this.closeMenus()
      }
    },

    toggleChldrenProducts (product, childProduct) {
      if (product) {
        this.isProductsChildrenOpen = !this.isProductsChildrenOpen
        this.childrenCat = product.children
        this.childrenCatTitle = product.title
        this.parentProduct = product
      }

      if (childProduct) {
          this.isProductsChildrenOpen = true
          this.prevProduct = childProduct
          this.childrenCat = this.prevProduct.children
          this.childrenCatTitle = this.prevProduct.title
      }

    },

    closeChldrenProducts () {
      if (this.prevProduct) {
          this.isProductsChildrenOpen = true
          this.childrenCat = this.parentProduct.children
          this.childrenCatTitle = this.parentProduct.title
          this.prevProduct = null
      } else if (this.prevProduct === null && this.parentProduct) {
            this.isProductsChildrenOpen = false
            this.parentProduct = null
      } else {
        this.isProductsChildrenOpen = false
        this.childrenCat = []
      }

    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Category.vue